module.exports = __webpack_public_path__ + "media/images/c-adminSidebarLink/fund_documents-c5b0e51da89b9e30d2ce411b2655e856.svg";